/* Version: 3.5.137 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var linkedinIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("path", {
      d: "M14,13.9760907 L11.1009936,13.9760907 L11.1009936,9.43657817 C11.1009936,8.35413756 11.0803447,6.96141903 9.593619,6.96141903 C8.08298401,6.96141903 7.852585,8.14058376 7.852585,9.35832945 L7.852585,13.9760907 L4.95466542,13.9760907 L4.95466542,4.64112715 L7.73629871,4.64112715 L7.73629871,5.9164726 L7.77596646,5.9164726 C8.16286291,5.18234746 9.10999845,4.40855457 10.5217358,4.40855457 C13.4571495,4.40855457 14,6.34140661 14,8.85569011 L14,13.9760907 Z M1.68343425,3.36469492 C0.750970346,3.36469492 0,2.61046421 0,1.68180407 C0,0.75423071 0.750970346,0 1.68343425,0 C2.611551,0 3.36523832,0.75423071 3.36523832,1.68180407 C3.36523832,2.61046421 2.611551,3.36469492 1.68343425,3.36469492 Z M0.230399006,13.9760907 L3.13483931,13.9760907 L3.13483931,4.64112715 L0.230399006,4.64112715 L0.230399006,13.9760907 Z"
    })]
  });
});

export { linkedinIcon as default };
